(() => {
  'use strict';

  const MODULE_SELECTOR = '[data-bm-lead-module]';
  const STORAGE_PREFIX = 'bm_vehicle_search_draft_v1:';

  const getStorage = () => {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  };

  const isDraftField = (field) => {
    if (!field || !field.name || !field.name.startsWith('contact[')) return false;
    return !['hidden', 'submit', 'button', 'reset', 'file'].includes(field.type);
  };

  const readDraft = (fields) => {
    const draft = {};
    fields.forEach((field) => {
      if (field.type === 'checkbox' || field.type === 'radio') {
        if (!draft[field.name]) draft[field.name] = [];
        if (field.checked) draft[field.name].push(field.value);
        return;
      }
      draft[field.name] = field.value;
    });
    return draft;
  };

  const restoreDraft = (fields, draft) => {
    fields.forEach((field) => {
      if (!Object.prototype.hasOwnProperty.call(draft, field.name)) return;
      const value = draft[field.name];

      if (field.type === 'checkbox' || field.type === 'radio') {
        field.checked = Array.isArray(value) && value.includes(field.value);
        return;
      }

      if (typeof value === 'string') field.value = value;
    });
  };

  document.querySelectorAll(MODULE_SELECTOR).forEach((module) => {
    const form = module.querySelector('form');
    if (!form) return;

    const storage = getStorage();
    const context = module.dataset.bmLeadContext || 'vehicle';
    const storageKey = `${STORAGE_PREFIX}${window.location.pathname}:${context}`;
    const nativeSuccess = module.querySelector('[data-bm-search-success]');
    const clientSuccess = module.querySelector('[data-bm-search-client-success]');
    const errorBox = module.querySelector('.bm-search-request-v2__error');
    let successSignal = Boolean(nativeSuccess);

    try {
      const url = new URL(window.location.href);
      successSignal = successSignal || url.searchParams.get('bm_search_submitted') === '1' || url.searchParams.has('contact_posted');
    } catch (error) {
      // Native success remains the fallback signal.
    }

    if (errorBox) {
      if (storage) {
        try {
          const draft = JSON.parse(storage.getItem(storageKey) || 'null');
          if (draft && typeof draft === 'object') restoreDraft(Array.from(form.elements).filter(isDraftField), draft);
        } catch (error) {
          storage.removeItem(storageKey);
        }
      }
      return;
    }

    if (successSignal) {
      storage?.removeItem(storageKey);
      module.classList.add('is-success');

      let success = nativeSuccess;
      if (!success && clientSuccess) {
        form.hidden = true;
        clientSuccess.hidden = false;
        success = clientSuccess;
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.delete('bm_search_submitted');
        url.searchParams.delete('contact_posted');
        window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`);
      } catch (error) {
        // URL cleanup is cosmetic and must never affect the success state.
      }

      window.requestAnimationFrame(() => {
        success?.focus({ preventScroll: true });
        const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
        module.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
      return;
    }

    if (!storage) return;

    const fields = Array.from(form.elements).filter(isDraftField);

    form.addEventListener('submit', () => {
      try {
        storage.setItem(storageKey, JSON.stringify(readDraft(fields)));
      } catch (error) {
        // Form submission must never depend on draft recovery.
      }
    });
  });
})();